export default __webpack_public_path__ + "static/media/September2.c818c7b2.mp3";